// Keep the same operation across a network failure or page reload. The server
// also guards the order itself, including submissions from another tab/user.
const operations = new Map<number, string>();
const storageKey = (id: number) => `distributor-submit-${id}`;

export function submissionOperation(id: number): string {
  let key = operations.get(id);
  try { key = key || sessionStorage.getItem(storageKey(id)) || undefined; } catch { /* private storage */ }
  key = key || crypto.randomUUID();
  operations.set(id, key);
  try { sessionStorage.setItem(storageKey(id), key); } catch { /* retain in memory */ }
  return key;
}

export function clearSubmissionOperation(id: number) {
  operations.delete(id);
  try { sessionStorage.removeItem(storageKey(id)); } catch { /* private storage */ }
}
